let storageEmpInfo = {}
let limitTime = {}
const avatarImgDirective = {}
avatarImgDirective.install = Vue => {
    Vue.directive('avatarShow', {
        beforeMount(el,binding) {
            let nowDate = new Date().getTime()
            if(el.dataset['toresetimg'] == 'true'){
                limitTime[binding.value] = null
                storageEmpInfo[binding.value] = null
            }
            if(nowDate > limitTime[binding.value]){
                limitTime[binding.value] = null
                storageEmpInfo[binding.value] = null
            }
            if(binding.value && storageEmpInfo[binding.value] && storageEmpInfo[binding.value] != 'noAvatarUrl'){
                el.style.overflow = 'hidden';
                return el.innerHTML=`<img style="width: 100%;height: 100%;object-fit: cover;" src="${storageEmpInfo[binding.value]}">`
            }
            else if(binding.value && (!storageEmpInfo[binding.value] || storageEmpInfo[binding.value] != 'noAvatarUrl')){
                Vue.config.globalProperties.$http.post(Vue.config.globalProperties.$api.org.user.queryEmpAAS,{emp_id:binding.value.toString()}).then((res)=>{
                    if(res.payload){
                        if(res.payload.emp_avatarUrl){
                            storageEmpInfo[binding.value] = res.payload.emp_avatarUrl
                            limitTime[binding.value] = new Date().getTime() + 60 * 1000 * 60;
                            el.style.overflow = 'hidden';
                            return el.innerHTML=`<img style="width: 100%;height: 100%;object-fit: cover;" src="${storageEmpInfo[binding.value]}">`
                        }
                        else{
                            storageEmpInfo[binding.value] = 'noAvatarUrl'
                            limitTime[binding.value] = new Date().getTime() + 60 * 1000 * 60;
                        }
                    }
                })
            }
        },
    }) 
}

export default avatarImgDirective